import React from 'react';

const LabOrderItemKeyValueDetails = (props) => {
    const {meta_data} = props;
    if(Object.entries(meta_data).length > 0 && meta_data !== null){
        return (
            <>
                <div className="key-value-details-holder">
                    {
                        Object.entries(meta_data).map((value, index) => {
                            return (
                                <div className="key-value-item" key={index}>
                                    <div className="key">{value[1]['title']}</div>
                                    <div className="value">{value[1]['value']}</div>
                                </div>
                            )
                        })
                    }
                    {/* <div className="key-value-item">
                        <div className="key">هزینه اعلام شده</div>
                        <div className="value">170000 هزار تومان</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">نوع نمونه</div>
                        <div className="value">ادرار - خون</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">ناشتایی</div>
                        <div className="value">ندارد</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">تاریخ نمونه‌برداری</div>
                        <div className="value">۱۴۰۰/۱۱/۱۹</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">بازه زمانی</div>
                        <div className="value">۸ الی ۱۰ صبح</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">نام نمونه‌گیر</div>
                        <div className="value">اصغر محمدی</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">شماره همراه</div>
                        <div className="value">09123456789</div>
                    </div>
                    <div className="key-value-item">
                        <div className="key">تاریخ تقریبی ارسال نتیجه</div>
                        <div className="value">۱۴۰۰/۱۱/۲۹</div>
                    </div> */}
                </div>
            </>
        )
    }else{
        return null;
    }
};

export default LabOrderItemKeyValueDetails;